import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (
      pathname === "/privacy-policy" ||
      pathname === "/voting-rule" ||
      pathname === "/terms-of-use"
    ) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;
